import { useEffect } from "react";
import useRole from "./useRole";
import { FULL_ACCESS_ROLES } from "constants/resources";
import { fetchRolePermissions } from "services/rolePermissions";

const SYNC_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export default function usePermissionsSync() {
  const { role } = useRole();

  useEffect(() => {
    if (!role || FULL_ACCESS_ROLES.includes(role)) return;

    const sync = async () => {
      try {
        const permissions = await fetchRolePermissions(role);
        localStorage.setItem(
          "ichigo_admin_permissions",
          JSON.stringify(permissions),
        );
      } catch {
        // Silently fail - keep existing permissions
      }
    };

    const interval = setInterval(sync, SYNC_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [role]);
}
